import { Context } from 'react'
import { useTranslation } from 'react-i18next'
import { hasPermission } from 'src/components/common/Authorization'
import { permissionValue } from 'src/enums/permissionValue'
import { MinimalDataDeviationsTable } from '../../deviations/MinimalDataDeviationsTable'
interface EquipmentDeviationTableProps {
  customerId: EntityId
  localityId?: EntityId
  positionId?: EntityId
  mainComponentId?: EntityId
  isDisabledButton?: boolean
  context?: React.Context<any>
  pop?: () => void
  height?: number
  permission?: number
  autoHeight?: boolean
  maxHeight?: number
  enableDelete?: boolean
  serviceStationId?: EntityId
  storageId?: EntityId
  selectedLocalityId?: EntityId
  status?: boolean
  maximumVisibleRowCount?: number
  minimalEmptyStatus?: boolean
  isReadOnly?: boolean
  isLocalityPortal?: boolean
}

const EquipmentDeviations: React.FC<EquipmentDeviationTableProps> = ({
  customerId,
  localityId,
  mainComponentId,
  context,
  height,
  autoHeight,
  maxHeight,
  permission,
  serviceStationId,
  storageId,
  pop,
  status,
  selectedLocalityId,
  maximumVisibleRowCount,
  minimalEmptyStatus,
  isReadOnly,
  isLocalityPortal,
}) => {
  const { t } = useTranslation(['main-component'])
  return (
    <MinimalDataDeviationsTable
      customerId={customerId!}
      mainComponentId={mainComponentId}
      queryParams={{ mainComponentId, status }}
      context={context as Context<any>}
      pop={pop}
      enableDelete={hasPermission(
        [
          permissionValue.Locality.MainComponent.Deviation.Delete,
          permissionValue.ServiceStation.Delete,
          permissionValue.ClientAdminPermission,
          permissionValue.ClientAdminPortal.Equipment_Portal,
        ],
        permission,
      )}
      updatePermissions={[
        permissionValue.Locality.MainComponent.Deviation.Write,
        permissionValue.ServiceStation.Write,
        permissionValue.ClientAdminPermission,
        permissionValue.ClientAdminPortal.Equipment_Portal,
      ]}
      deletePermissions={[
        permissionValue.Locality.MainComponent.Deviation.Delete,
        permissionValue.ServiceStation.Delete,
        permissionValue.ClientAdminPermission,
        permissionValue.ClientAdminPortal.Equipment_Portal,
      ]}
      permission={permission}
      enablePagination={false}
      autoHeight={autoHeight}
      height={height}
      maxHeight={maxHeight}
      serviceStationId={serviceStationId}
      emptyStatusTitle={t(
        status ? 'main-component-close-deviation-empty-status-title' : 'main-component-deviation-empty-status-title',
        { ns: 'main-component' },
      )}
      emptyStatusContent={t(
        status
          ? 'main-component-close-deviation-empty-status-content'
          : 'main-component-deviation-empty-status-content',
        { ns: 'main-component' },
      )}
      emptyStatusTitleFontSize="16px"
      emptyStatusContentFontSize="14px"
      storageId={storageId}
      localityId={localityId}
      selectedLocalityId={selectedLocalityId}
      emptyStatusImageWidth="80px"
      minimalEmptyStatus={minimalEmptyStatus}
      maximumVisibleRowCount={maximumVisibleRowCount}
      disabled={isReadOnly}
      isLocalityPortal={isLocalityPortal}
    />
  )
}

export default EquipmentDeviations
